import dashboard from "../assets/dash.png";
import { texts } from "../data/langs";
import feather from "feather-icons";
import "../App.css";

export const Home = (props) => {
  const { setContact } = props;
  const toggleContact = () => {
    setContact((e) => !e);
  };

  return (
    <section className="limiter" id="Home">
      <div className="GAP-H40" />
      <div className="GAP-H40" />

      <h1 className="limiter2">{texts[texts.active].home.h1}</h1>
      <h3 className="limiter2">{texts[texts.active].home.h3}</h3>

      <div className="GAP-H40" />
      <div className="GAP-H40" />

      <div className="callToAct line">
        <div style={{ width: 200 }}>
          <a
            // href="https://api.whatsapp.com/send?phone=5511916745093&text=Olá%2C+vi+seu+anúncio+no+Google+e+quero+mais+informações+sobre+o+desenvolvimento+de+software."
            // target="_blank"
            className="btn1"
            onClick={toggleContact}
            // onClick={() => {
            //   window.gtag &&
            //     window.gtag("event", "conversion", {
            //       send_to: "AW-17225078986/gNAbCLef2d0aEMqxx5VA",
            //     });
            // }}
          >
            {texts[texts.active].home.btn1}
          </a>

          <span>{texts[texts.active].home.span1}</span>
        </div>

        {/* <div className="GAP-10" />

        <button className="btn2">
          <div
            style={{ width: 25 }}
            dangerouslySetInnerHTML={{
              __html: feather.icons["play-circle"].toSvg({
                class: "foo bar",
                "stroke-width": 3,
                stroke: "#fff",
                width: 14,
                height: 14,
              }),
            }}
          />
          {texts[texts.active].home.btn2}
        </button> */}
      </div>

      <div className="GAP-H20" />
      <div className="GAP-H20" />
      <div className="GAP-H20" />

      <img src={dashboard} className="dash" alt="panel" />
    </section>
  );
};
